import { Icon } from "common/Icon";
import { fullscreenMessages } from "common/MapV2/controls/FullscreenButton";
import { Msg } from "lib/localization";
import React from "react";
import styles from "./FullscreenButton.scss";

export class FullscreenButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
    };
  }

  componentDidMount() {
    this.setState({ isMounted: true });
  }

  render() {
    const { padDown, heightRef } = this.props;
    let top;
    if (padDown) {
      top = heightRef ? heightRef + 70 : 135;
    } else {
      top = 70;
    }

    return (
      <FullscreenContext.Consumer>
        {({ isFullscreen, toggleFullscreen, mobileCollapse }) => (
          <div
            className={styles.FullscreenButton}
            style={{
              left: isFullscreen || mobileCollapse ? "10px" : "410px",
              top: `${top}px`,
            }}
          >
            <button
              ref={(r) => {
                this._button = r;
              }}
              onClick={toggleFullscreen}
            >
              <Icon i={isFullscreen ? "md-contract" : "md-expand"} />
              <Msg m={isFullscreen ? fullscreenMessages.exit : fullscreenMessages.fullscreen} />
            </button>
          </div>
        )}
      </FullscreenContext.Consumer>
    );
  }
}

export const FullscreenContext = React.createContext({
  isFullscreen: false,
  toggleFullscreen: () => {},
});
